import { useEffect, useRef } from "react";
import { usePhoenixForms } from "./PhoenixFormsProvider";


export const usePhoenixFormsSaveComplete = (callback: () => void) => {
  const { subscribeToOnSaveSuccess } = usePhoenixForms();
  const callbackRef = useRef<() => void>(callback);

  // Update the ref when callback changes
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  // Subscribe to on save success and automatically handle unsubscribing when unmounted
  useEffect(() => {
    const unsubscribe = subscribeToOnSaveSuccess(() => {
      callbackRef.current();
    });

    return () => {
      unsubscribe();
    };
  }, []);
}

export default usePhoenixFormsSaveComplete;